// extracted by mini-css-extract-plugin
export var columnItem = "_al-3";
export var columnItemDraggable = "_al-4";
export var dragHandle = "_al-0";
export var dragHandleHovered = "_al-1";
export var dropdown = "_al-5";
export var dropdownContent = "_al-7";
export var dropdownInner = "_al-6";
export var filterDropdownHeader = "_al-8";
export var icon = "_al-2";
export var sectionDivider = "_al-9";